<template>
  <el-dialog
      :visible.sync="visible"
      title="确认收货"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="凭证照片：" prop="imgs" style="margin-bottom: 0;">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500">
        <el-table-column label="订单编号" prop="orderCode" align="center" width="160" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="发货批次" prop="batchCode" align="center" width="160" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="发货工厂" prop="senderName" align="center" width="160" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="发货日期" prop="sendDate" align="center" width="120" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="货品信息" prop="product.code" align="center">
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="计划数" prop="planCount" align="center" width="120">
        </el-table-column>
        <el-table-column label="已收货数" prop="totalReceiveCount" align="center" width="120">
        </el-table-column>
        <el-table-column label="本批发货数" prop="receiveCount" align="center" width="120">
          <template v-slot="scope">
            <el-form-item
                :rules="detailRule.count"
                :prop="'detailList.' + scope.$index + '.receiveCount'"
                label-width="0"
            >
              <el-input v-model="scope.row.receiveCount" size="mini" :placeholder="scope.row.sendCount"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="收货日期" align="center" width="160">
          <template v-slot="scope">
            <el-form-item
                :rules="detailRule.receiveOptTime"
                :prop="'detailList.' + scope.$index + '.receiveOptTime'"
                label-width="0"
            >
              <el-date-picker
                  v-model="scope.row.receiveOptTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="选择时间"
                  size="mini"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="备注"
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.remark'"
                label-width="0"
            >
              <el-input v-model="scope.row.remark" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle">确认收货</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 公司端统一收货弹窗
 */
import ProductRowCard from '@/components/ProductRowCard.vue'
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import { countValidator, moneyValidator } from '@/utils/validate'
import moment from 'moment'
import BigNumber from 'bignumber.js'

export default {
  components: { MultipleImageUpload, ProductRowCard },
  data () {
    return {
      visible: false,
      dataForm: {},
    }
  },
  computed: {
    detailRule () {
      return {
        count: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: countValidator,
            trigger: 'change',
          },
        ],
        receiveOptTime: [{
          required: true,
          message: this.$t('validate.required'),
          trigger: 'change',
        }]
      }
    },
    dataRule () {
      return {}
    }
  },
  methods: {
    init (detailList) {
      this.dataForm = {
        imgs: '',
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = []
      let hasOver = false
      for (let i = 0; i < this.dataForm.detailList.length; i++) {
        let row = this.dataForm.detailList[i]
        if (!row.receiveCount || row.receiveCount == 0) {
          continue
        }
        if (new BigNumber(row.receiveCount).plus(row.totalReceiveCount).gte(row.planCount)) {
          try {
            await this.$confirm('有超出计划数量的收货，是否继续？','操作提示')
            hasOver = true
          } catch (e) {
            return
          }
        }
        postForm.push({
          id: row.id,
          receiveCount: row.receiveCount,
          receiveOptTime: row.receiveOptTime,
          receiveImgs: this.dataForm.imgs,
          receiveRemark: row.remark
        })
      }
      try {
        this.loading = true
        const res = await this.$api2
            .post('/trade/factorystorelog/receive', postForm)
        this.$c.success('保存成功').then(() => {
          this.visible = false
          this.$emit('change')
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }

    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function () {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                this.doSave()
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
